import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getProductCatalogueTemplatesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/product-catalogue-templates")({
    loader: async ({context}) => {
        const productCatalogueTemplatesResult = await getProductCatalogueTemplatesWithCaching({
            workspaceId: context.workspace.id,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
        });

        if (productCatalogueTemplatesResult.success !== true) {
            throw new Error("Failed to fetch product catalogue templates");
        }

        const productCatalogueTemplates = productCatalogueTemplatesResult.data;

        return {
            productCatalogueTemplates: productCatalogueTemplates,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
